"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./in-dom");
var size;
function scrollbarSize(recalc) {
    if (!size || recalc) {
        if (in_dom_1.inDOM) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return size;
}
exports.scrollbarSize = scrollbarSize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/util/scrollbar-size.js
// module id = 468
// module chunks = 0 1 2 3 4 5 6